import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { UserCouponResponse } from '@models/coupon';
import { useTranslation } from 'react-i18next';

interface Props {
    coupon: UserCouponResponse;
}

const getCouponStatusKey = (status: string): string => {
    const statusMap: Record<string, string> = {
        ISSUED: 'status.issued',
        USED: 'status.used',
        EXPIRED: 'status.expired',
        CANCELLED: 'status.cancelled',
    };
    return statusMap[status] || status;
};

function CouponImageCard({ coupon }:Props) {
    const { imageUrl, status } = coupon;
    const { t } = useTranslation('coupon');
    return (
        <Card>
            <ImageContainer>
                <Image src={imageUrl}
                    width={124}
                    height={124}
                    alt={t('detail.couponImageAlt')} />
                {status !== 'ISSUED' && (
                    <DisaledOverlay >
                        <Text size='s' fontWeight='bold' color={colors.gray7} align='center'>
                            {t(getCouponStatusKey(status))}
                        </Text>
                    </DisaledOverlay>
                )}
            </ImageContainer>
        </Card>
    );
}

const Card = styled.div`
    background-color: var(--color-primary);
    display: flex;
    justify-content: center;
    margin-bottom: 28px;
    padding: 26px 0;
    width: calc(100% - 48px);
`;

const ImageContainer = styled.div`
    align-items: center;
    background-color: var(--color-gray2);
    border: 1px solid var(--color-gray2);
    border-radius: 62px;
    box-shadow: 0 0 4.96px 0 rgba(0, 0, 0, 0.14);
    display: flex;
    height: 124px;
    justify-content: center;
    position: relative;
    width: 124px;
    overflow: hidden;
`;

const DisaledOverlay = styled.div`
    background: linear-gradient(0deg, rgba(196, 131, 114, 0.16) 0%, rgba(196, 131, 114, 0.16) 100%), rgba(255, 255, 255, 0.65);
    height: 25px;
    padding: 3px 0 2px;
    position: absolute;
    text-align: center;
    transform: rotate(-18.17deg);
    width: 88px;
`;

export default CouponImageCard;
